import React from 'react';
import { useSupplementsList } from '../../contextsProperty/ContextSupplements';
import { useSearchParams } from '../../../customHooks/useSearchParams';
import SupplementsFiltersBar from './SupplementsFiltersBar';
import { SupplementListViewType } from '../../../types/supplement/supplementsTypes';
import SupplementsTable from './tableView/SupplementsTable';
import SupplementsCalendar from './calendarView/SupplementsCalendar';
import SupplementPanel from './supplementPanel/SupplementPanel';
import '../../../stylesheets/stylesLayout/supplements-page.scss';
import { getCSSVariable } from '../../../stylesheets/cssVariablesUtils';
import useIsMobile from '../../../customHooks/useIsMobileQuery';
import SupplementsCards from './tableView/SupplementsCardsView';

const Supplements = () => {
    const { visibleView } = useSupplementsList();
    const { getSearchParam, removeSearchParam } = useSearchParams({
        base64: true,
    });
    const openedPanelSupplementId = getSearchParam('id');

    const handleClosePanel = () => {
        removeSearchParam('id');
    };

    const mobileBreakpoint = parseInt(getCSSVariable('lg'));
    const isMobile = useIsMobile(mobileBreakpoint);

    return (
        <div className='supplements__page'>
            <SupplementsFiltersBar />
            {visibleView === SupplementListViewType.TABLE ? (
                isMobile ? (
                    <SupplementsCards />
                ) : (
                    <SupplementsTable />
                )
            ) : (
                <SupplementsCalendar />
            )}
            <SupplementPanel
                open={!!openedPanelSupplementId}
                onClose={handleClosePanel}
            />
        </div>
    );
};

export default Supplements;
